import restClient from "../restClient";

export const getReports = async (tab, selectedUserIds, search = '', page = 1, pageSize = 20) => {
  try {
    const token = localStorage.getItem('token');
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await restClient.get(`reports?type=${tab}&owners=${selectedUserIds.join(',')}&search=${search}&pagination[page]=${page}&pagination[pageSize]=${pageSize}`, config);
    return response.data;
  } catch (err) {
    console.log(err);
    return null;
  }
};

export const getRecordSpecificReports = async (recordType = 'account', pageSize = 500) => {
  try {
    const token = localStorage.getItem('token');
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await restClient.get(
      `reports?spec_record_type=${encodeURIComponent(recordType)}&pagination[page]=1&pagination[pageSize]=${pageSize}`,
      config
    );
    return response.data;
  } catch (err) {
    console.log(err);
    return null;
  }
};

export const getReportTable = async (id) => {
  try {
    const token = localStorage.getItem('token');
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await restClient.get(`report-tables/${id}`, config);
    return response.data;
  } catch (err) {
    console.log(err);
    return null;
  }
};

export const getReportDetail = async (id) => {
  try {
    const token = localStorage.getItem('token');
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await restClient.get(`reports/${id}`, config);
    return response.data;
  } catch (err) {
    console.log(err);
    throw err;
  }
};

export const createReport = async (data) => {
  try {
    const token = localStorage.getItem('token');
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await restClient.post(`reports`, { data: data }, config);
    return response?.data;
  } catch (err) {
    console.log(err);
    return null;
  }
};

export const deleteReport = async (id) => {
  try {
    const token = localStorage.getItem('token');
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await restClient.delete(`reports/${id}`, config);
    return response.data;
  } catch (err) {
    console.log(err);
    return null;
  }
};

export const updateReport = async (id, data) => {

  try {
    const token = localStorage.getItem('token');
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await restClient.put(`reports/${id}`, { data: data }, config);
    return response.data;
  } catch (err) {
    console.log(err);
    throw err;
  }
};

export const generateReport = async (id, format = null, runtimeParams = {}) => {
  try {
    const token = localStorage.getItem('token');
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json'
      },
    };
    const queryParts = [];
    if (format === 'pdf') {
      queryParts.push('format=pdf');
    } else if (format === 'excel') {
      queryParts.push('format=excel');
    } else if (format === 'csv') {
      queryParts.push('format=csv');
    } else {
      queryParts.push('format=html');
    }
    if (runtimeParams.acct_id) {
      queryParts.push(`acct_id=${encodeURIComponent(runtimeParams.acct_id)}`);
    }
    const type = `?${queryParts.join('&')}`;
    const body = runtimeParams.acct_id ? { data: { acct_id: runtimeParams.acct_id } } : {};
    const response = await restClient.post(`create-report/${id}${type}`, body, config);
    return response; // Return full response object instead of response.data
  } catch (err) {
    console.log(err);
    throw err;
  }
};

export const generateReportPage = async (
  id,
  page = 1,
  pageSize = 50,
  runtimeParams = {}
) => {
  const token = localStorage.getItem('token');
  const query = new URLSearchParams({
    page: String(page),
    pageSize: String(pageSize),
  });
  if (runtimeParams.acct_id) {
    query.set('acct_id', runtimeParams.acct_id);
  }
  const body = runtimeParams.acct_id
    ? { data: { acct_id: runtimeParams.acct_id } }
    : { data: {} };
  const response = await restClient.post(
    `report-preview/${id}?${query.toString()}`,
    body,
    {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    }
  );
  return response.data;
};

export const enqueueReportExport = async (id, format, runtimeParams = {}) => {
  const token = localStorage.getItem('token');
  const query = new URLSearchParams({ format });
  if (runtimeParams.acct_id) query.set('acct_id', runtimeParams.acct_id);
  const body = runtimeParams.acct_id
    ? { data: { acct_id: runtimeParams.acct_id } }
    : { data: {} };
  const response = await restClient.post(
    `report-jobs/${id}?${query.toString()}`,
    body,
    {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    }
  );
  return response.data?.data;
};

export const getReportExportJob = async (jobId) => {
  const token = localStorage.getItem('token');
  const response = await restClient.get(`report-jobs/${jobId}`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return response.data?.data;
};

export const downloadReportExportJob = async (jobId) => {
  const token = localStorage.getItem('token');
  const response = await restClient.get(`report-jobs/${jobId}/download`, {
    headers: { Authorization: `Bearer ${token}` },
    responseType: 'blob',
  });
  return response;
};

export const downloadScheduleReportCsv = async (id, data) => {
  const token = localStorage.getItem('token');
  const response = await fetch(`${process.env.REACT_APP_API_URL}create-report/${id}?format=csv`, {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ data }),
  });

  if (!response.ok) {
    const text = await response.text();
    let message = text;
    try {
      const json = JSON.parse(text);
      message = json?.error?.message || json?.message || text;
    } catch {
      // keep raw text
    }
    throw new Error(message || `HTTP error! status: ${response.status}`);
  }

  return response.blob();
};

export const favoriteReport = async (report_id) => {
  try {
    const token = localStorage.getItem('token');
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await restClient.put(`account/favorite-report`, { report_id }, config);
    return response.data;
  } catch (err) {
    console.log(err);
    throw err;
  }
};

export const duplicateReport = async (id) => {
  try {
    const token = localStorage.getItem('token');
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await restClient.post(`reports/duplicate`, { data: { id } }, config);
    return response.data;
  } catch (err) {
    console.log(err);
    throw err;
  }
};

export const generateInventoryTaxReport = async (data) => {
  try {
    const token = localStorage.getItem('token');
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      responseType: 'blob'
    };
    const response = await restClient.post(`reports/inventory-tax-report`, { data: data }, config);
    return response.data;
  } catch (err) {
    console.log(err);
    throw err;
  }
};

export const generateSalesTaxReport = async (data) => {
  try {
    const token = localStorage.getItem('token');
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      responseType: 'blob'
    };
    const response = await restClient.post(`reports/sales-tax-report`, { data: data }, config);
    return response.data;
  } catch (err) {
    console.log(err);
    throw err;
  }
};

export const getTaxInfos = async () => {
  try {
    const token = localStorage.getItem('token');
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await restClient.get(`tax-infos`, config);
    return response.data;
  } catch (err) {
    console.log(err);
    return null;
  }
};

export const generateDailyReport = async (data) => {
  try {
    const token = localStorage.getItem('token');
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await restClient.post(`reports/daily-report`, { data: data }, config);
    return response.data;
  } catch (err) {
    console.log(err);
    throw err;
  }
};